import times from 'lodash/times';
import { Line, Rect } from 'react-konva';
import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';

import {
  COLUMN_WIDTH,
  COLUMN_HEIGHT,
} from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';

import { LINES_COUNT } from './current-not-active-day-column.constants';

const getStrokeColor = (colorSchema: any, isHoliday: boolean) => {
  const strokeColor = isHoliday
    ? colorSchema?.todayColor || PLATFORM_THEME_COLORS.grayVariations.light
    : colorSchema?.weekendColor;

  if (strokeColor === PLATFORM_THEME_COLORS.grayVariations.athensGray) {
    return PLATFORM_THEME_COLORS.grayVariations.light;
  }

  return strokeColor;
};

const CurrentNotActiveDayColumn = ({
  elementPoints,
  isHoliday,
  colorSchema,
}: {
  elementPoints: number[];
  isHoliday: boolean;
  colorSchema: any;
}) => {
  const [startX, startY, endX, endY] = elementPoints;

  const diagonalPartCount = LINES_COUNT / 2;
  const lineFromXOffset = COLUMN_WIDTH / diagonalPartCount;
  const lineFromYOffset = COLUMN_HEIGHT / diagonalPartCount;
  const divideXOffset = lineFromXOffset / 2;
  const divideYOffset = lineFromYOffset / 2;
  const strokeColor = getStrokeColor(colorSchema, isHoliday);

  return (
    <>
      {isHoliday && (
        <Rect
          x={startX}
          perfectDrawEnabled={false}
          y={startY}
          width={COLUMN_WIDTH}
          height={COLUMN_HEIGHT}
          fill={colorSchema?.holidayColor || PLATFORM_THEME_COLORS.tone.markYellow}
        />
      )}
      {times(diagonalPartCount).map(count => (
        <Line
          key={`right-top-${count}`}
          points={[
            startX + count * lineFromXOffset + divideXOffset,
            startY,
            endX,
            endY - lineFromYOffset * count - divideXOffset,
          ]}
          strokeWidth={2}
          stroke={strokeColor}
        />
      ))}

      {times(diagonalPartCount).map(count => (
        <Line
          key={`left-bottom-${count}`}
          points={[
            startX,
            startY + count * lineFromYOffset + divideYOffset,
            endX - lineFromXOffset * count - divideYOffset,
            endY,
          ]}
          strokeWidth={2}
          stroke={strokeColor}
        />
      ))}
    </>
  );
};

export default CurrentNotActiveDayColumn;
